app.controller("LecturerGroupController", ["$scope", "Session", "Selection", "Subject", "Users", "$uibModal", "$stateParams", "$state","usSpinnerService",
    function ($scope, Session, Selection, Subject, Users, $uibModal, $stateParams, $state, usSpinnerService) {
        $scope.lecturer = $stateParams.lecturer;
        var subjectActivation, lecturerId;
        var groupId = $stateParams.groupId;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 25;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {

                };
            usSpinnerService.spin("root");

            Session.findGroupById(groupId).then(function (data) {
                $scope.session = data;
                lecturerId = data.lecturer;
                subjectActivation = data.subjectActivation;

                Users.profile(lecturerId).then(function (data) {
                    return $scope.lecturer = data
                });
            }).then(function () {
                Selection.selectionsByActivation({
                    activationId: subjectActivation,
                    grades: true,
                    page: page,
                    limit: $scope.itemsPerPage,
                    group: groupId
                }).then(function (data) {
                    $scope.selections = data.docs;
                    $scope.totalItems = data.total;
                    usSpinnerService.stop("root");
                    cb();
                });
            })
        }

        $scope.details = function (selection, $event) {
            selection.name = $scope.session.subject.name;
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DetailsController",
                templateUrl: _pb + 'student/card/details.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    subject: function () {
                        return selection
                    }
                }
            }).result
                .then(function (result) {

                });
        };
    }
]);
